import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";

import createLink from "../../../../libs/createLink";
import Authenticated from "../../../../libs/Authenticated";

import {fetchForumComments, resetForumComments} from "../../../../creators/forums.comments";
import {deleteForumTopic, moveForumTopic, updateForumTopic} from "../../../../creators/forums.topic";
import {fetchForumBreadcrumbs, resetForumBreadcrumbs} from "../../../../creators/forums.breadcrumbs";
import {
    createForumComment,
    deleteForumComment,
    resetForumComment,
    updateForumComment
} from "../../../../creators/forums.comment";

import CommentsList from './CommentsList';
import Dropdown from '../../../components/Dropdown';
import Pagination from '../../../components/Pagination';
import {LoadingBar, SpinLoader} from '../../../components/Loader';
import {Button} from "../../../components/Button";
import TopicHeader from "./TopicHeader";
import {Can} from "../../../../ability-context";
import MkEditor from "../../../components/editor/Editor";
import Helmet from "react-helmet";
import {config} from "../../../../config";
import {canonical, contentRawToText, cropText} from "../../../../libs/helper";
import CtaCannot from "../../../components/CtaCannot";
import Breadcrumbs from "../../../components/Breadcrumbs";
import _ from "lodash";
import TopicFollows from "../../../components/follows/TopicFollows";

class Topic extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 20,
            sort: "createdAt",
            page: 1,
            isFirstPost : false
        };
        this.initialTopicComment = {
            contentRaw: {},
            useSign: (this.props.currentUser.setting && this.props.currentUser.setting.signature && this.props.currentUser.setting.signature.display) || false,
            edit : {},
        };
        this.state = {
            filter: {...this.filter, page: this.props.match.params.page || 1},
            topicComment: this.initialTopicComment,
            errorContent: false,
            multipleQuotes: [],
            quotesIds: [],
            multipleCheckbox: [],
            loadingActionGroup: false,
            quoteIds: [],
            waitingDraft: true,
        };

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangement = this.handleChangement.bind(this);
        this.handleResetContent = this.handleResetContent.bind(this);
        this.closeToggleAnswer = this.closeToggleAnswer.bind(this);
        this.handleIncludeSign = this.handleIncludeSign.bind(this);
        this.submitQuotations = this.submitQuotations.bind(this);
        this.quote = this.quote.bind(this);
        this.handleMultipleCheckbox = this.handleMultipleCheckbox.bind(this);
        this.handleActionGroup = this.handleActionGroup.bind(this);
        this.handleMultipleQuotes = this.handleMultipleQuotes.bind(this);
        // this.handleCreateDraft = this.handleCreateDraft.bind(this);
        this.resetComment = this.resetComment.bind(this);

        this.editorRef = React.createRef();
        if(this.props.forumId && this.props._id){
            this.props.fetchForumComments(this.props.forumId, this.props._id, this.state.filter);
        }
        if(this.props._id){
            this.props.fetchForumBreadcrumbs(this.props.forumId);
        }


    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        this.props.resetForumComments();
        this.props.resetForumBreadcrumbs();
        this.setState({filter: this.filter});
    }

    componentDidUpdate(prevProps) {

        if(prevProps.match.params.page !== this.props.match.params.page ){
            let filter = {...this.state.filter, page : this.props.match.params.page || 1};
            this.setState({filter});
            this.props.fetchForumComments(this.props.forumId, this.props._id, filter);
        }
        // if(prevProps.commentInitialized !== this.props.commentInitialized && this.props.comment.draft){
        //     this.setState({waitingDraft: false});
        // }

        if(prevProps.commentsTotal !== this.props.commentsTotal){
            if(this.props.commentsInitialized && this.props.commentsTotal >0){

                let totalPage = Math.ceil(this.props.commentsTotal / this.state.filter.limit);
                let currentPage = parseInt(this.props.match.params.page);

                if((currentPage > totalPage) || (this.props.redirectToLastPage && totalPage > 1)){
                    let ancre = "";
                    if((this.props.redirectToLastPage && totalPage > 1)){
                        ancre="#last-comment";
                    }
                    this.handleChangePage(totalPage,createLink("forumTopic", {categoryParent : {slug : this.props.match.params.slugParent}, category : {_id : this.props.forum._id, slug : this.props.forum.slug}, topic : {_id : this.props._id, slug : this.props.slug}}), ancre)
                }

            }
        }
        // if(this.props.commentInitialized && this.props.comment.draft !== prevProps.comment.draft && !this.props.comment.draft){
        //     this.props.resetForumComment();
        //     this.setState({waitingDraft: true});
        // }

    }

    handleMultipleCheckbox(commentId) {
        let multipleCheckbox = this.state.multipleCheckbox || [];
        if (multipleCheckbox.includes(commentId.toString())) {
            multipleCheckbox = multipleCheckbox.filter((e) => e && e._id && e._id.toString() !== commentId.toString());
            this.setState({multipleCheckbox})
        } else {
            this.setState({multipleCheckbox: [...multipleCheckbox, commentId.toString()]})
        }
    }

    handleMultipleQuotes(item) {
        let quotesIds = this.state.quotesIds || [];
        let multipleQuotes = this.state.multipleQuotes || [];
        if (quotesIds.includes(item._id.toString())) {
            quotesIds = quotesIds.filter((e) => (e && e.toString() !== item._id.toString()));
            multipleQuotes = multipleQuotes.filter((e) => e && e._id.toString() !== item._id.toString());
            this.setState({quotesIds, multipleQuotes})
        } else {
            this.setState({
                quotesIds: [...quotesIds, item._id.toString()],
                multipleQuotes: [...multipleQuotes, {
                    _id: item._id
                }]
            })
        }
    }

    quote(item) {
        // this.handleCreateDraft();
        let quoteIds = [];
        quoteIds.push(item._id);
        this.setState({quoteIds});
        window.scrollTo(0,document.body.scrollHeight);
    }

    handleChangePage(page, link, ancre = "") {
        let filter = {...this.state.filter, page};

        if (page === 1) {
            this.props.history.push(link+ancre);
        } else {
            this.props.history.push(link + '/' + page+ancre);
        }
        this.setState({filter});
        this.props.fetchForumComments(this.props.forumId, this.props._id, filter);
        if(ancre === ""){
            window.scrollTo(0, 0);
        }

    }

    handleChangement() {
        let totalPage = Math.ceil(this.props.commentsTotal / this.state.commentsLimit);
        if (totalPage > 0) {
            this.handleChangePage(totalPage, createLink("forumTopic", {categoryParent : {slug : this.props.match.params.slugParent},category : {slug : this.props.forum.slug, _id : this.props.forum._id}, topic : {_id : this.props._id, slug : this.props.slug}}) );
            let c = document.getElementsByClassName("content-wrapper");
            let last_element = c[c.length - 1];
            last_element && last_element.scrollIntoView(true);
            last_element && window.scrollBy(0, last_element.style.offsetHeight);
        }
    }

    closeToggleAnswer() {
        this.setState({toggleAnswer: false});
    }

    handleActionGroup(action = "") {
        let i = 0;
        switch (action) {
            case "hidden":
                this.setState({loadingActionGroup: false});
                i = 0;
                this.state.multipleCheckbox.forEach(item => {
                    i++;
                    if (i < this.state.multipleCheckbox.length) {
                        this.props.updateForumComment(this.props.forumId, this.props._id, item, {isApproved: false});
                    }
                    if (i === this.state.multipleCheckbox.length) {
                        this.props.updateForumComment(this.props.forumId, this.props._id, item, {isApproved: false});
                        this.setState({multipleCheckbox: []});
                    }
                });
                break;
            case "delete":
                this.setState({loadingActionGroup: false});
                i = 0;
                this.state.multipleCheckbox.forEach(item => {
                    i++;
                    if (i < this.state.multipleCheckbox.length) {
                        this.props.deleteForumComment(this.props.forumId, this.props._id, item);
                    }
                    if (i === this.state.multipleCheckbox.length) {
                        this.props.deleteForumComment(this.props.forumId, this.props._id, item);
                        this.setState({multipleCheckbox: []});
                    }
                });

                break;
            default:

        }
    }

    submitQuotations() {
        // this.handleCreateDraft();
        let quotes = [];
        let quoteIds = this.state.quotesIds;
        this.state.multipleQuotes.forEach(item => {
            quotes.push(item);
        });
        this.setState({quoteIds, quotes, multipleQuotes: [], quotesIds: []});
        window.scrollTo(0,document.body.scrollHeight);
    }

    handleIncludeSign() {
        this.setState({topicComment : {...this.state.topicComment, useSign: !this.state.useSign}});
    }

    handleResetContent() {
        this.setState({errorContent: false, topicComment : {...this.initialTopicComment, contentRaw: {}}});
    }

    // handleCreateDraft(){
    //     if(this.props.comment && this.props.comment._id === undefined && !this.props.commentInitialized){
    //         this.props.createForumComment(this.props.forumId, this.props._id);
    //     }
    // }

    resetComment() {
            this.props.resetForumComment();
            this.closeToggleAnswer();
            this.handleResetContent();
            this.editorRef.current.handleClear();
            this.setState({waitingDraft : true})
    }

    handleSubmit() {
        let hasText = this.editorRef.current.handleHasText();
        if(hasText){
            let files = {};
            let contentRaw = this.state.topicComment.contentRaw;
            let useSign = _.get(this.props.currentUser,"setting.signature.display");
            if(this.state.topicComment.contentRaw && this.state.topicComment.contentRaw.entityMap){
                // files = {
                //     ...files,
                //     "contentRaw.entityMap" : Object.values(this.state.article.contentRaw.entityMap)
                // };
                let contentFiles = Object.values(this.state.topicComment.contentRaw.entityMap);
                contentFiles.forEach((item,index) =>{
                    if(item.type === "UPLOADED_MEDIA" && item.data.id){
                        let key = `contentRaw.entityMap[${index}].data.uri`;
                        files = {
                            ...files,
                            [key] : item.data.id
                        }
                        if(contentRaw.entityMap[index].data && contentRaw.entityMap[index].data.id){
                            delete contentRaw.entityMap[index].data.id;
                        }
                    }
                });

            }
            this.props.createForumComment(this.props.forumId, this.props._id, {...this.state.topicComment, contentRaw, "_files" : files, useSign});
            this.props.resetForumComment();
            this.closeToggleAnswer();
            this.handleResetContent();
            this.editorRef.current.handleClear();
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.state !== nextState){
            return true;
        }
        if(this.props.commentsInitialized !== nextProps.commentsInitialized){
            return true;
        }
        if(this.props.commentSubmitting !== nextProps.commentSubmitting){
            return true;
        }
        if(this.props.commentsLoading !== nextProps.commentsLoading){
            return true;
        }
        if(this.props.comments !== nextProps.comments){
            return true;
        }
        if(this.props.commentsTotal !== nextProps.commentsTotal){
            return true;
        }
        if(this.props.forumTopicLoading !== nextProps.forumTopicLoading){
            return true;
        }
        if(this.props.currentUserInitialized !== nextProps.currentUserInitialized){
            return true;
        }
        if(this.props.isOpened !== nextProps.isOpened){
            return true;
        }
        if(this.props.breadcrumbs !== nextProps.breadcrumbs){
            return true;
        }
        if(this.props.isFollow !== nextProps.isFollow){
            return true;
        }
        return this.props.commentInitialized !== nextProps.commentInitialized;
    }

    render() {
        let totalPage = Math.ceil(this.props.commentsTotal / this.state.filter.limit);
        let url = createLink("forumTopic", {categoryParent : {slug : _.get(this.props,"match.params.slugParent") || ""},category : {slug : _.get(this.props,"forum.slug") || "", _id : _.get(this.props,"forum._id")}, topic : {_id : _.get(this.props,"_id"), slug : _.get(this.props,"slug") || ""}});
        let currentPage = parseInt(this.state.filter.page);
        // console.log(this.state.waitingDraft);
        let breadCrumbsData= [];
        if(this.props.breadcrumbsInitialized){
            breadCrumbsData.push({name : "Forum Sexe", link : canonical(createLink("forum"), "", "forum"), to : createLink("forum")});
            this.props.breadcrumbs.forEach((item, index) => {
                if(item.parentId === ""){
                    breadCrumbsData.push({name : item.name, link : canonical(`${createLink("forum")}/${item.slug}`, "", "forum"), to : `${createLink("forum")}/${item.slug}`});
                }
                else if(this.props.breadcrumbs && this.props.breadcrumbs[index-1] && this.props.breadcrumbs[index-1].parentId === ""){
                    breadCrumbsData.push({name : item.name, link : canonical(`${createLink("forum")}/${item.slug}`, "", "forum"), to : `${createLink("forum")}/${item.slug}`});
                }
                else{
                    breadCrumbsData.push({name : item.name, link : canonical(createLink("forumCategory", {categoryParent : {slug : _.get(this.props,"forum.slug") === item.slug ? this.props.breadcrumbs[index-1].slug : ""}, category : {_id : item._id, slug : item.slug || ""}}), "", "forumCategory"), to : createLink("forumCategory", {categoryParent : {slug : _.get(this.props,"forum.slug") === item.slug ? this.props.breadcrumbs[index-1].slug : ""},category : {_id : item._id, slug : item.slug || ""}})});
                }
                if(index === this.props.breadcrumbs.length-1){
                    breadCrumbsData.push({name : this.props.title, link : canonical(url, "", "topics"), to : url});
                }
            })
        }


        return (
            <Fragment>
                <div className={"topline"}>
                    <Helmet>
                        <title>{config.preTitle}{this.props.title} - {_.get(this.props,"forum.name") || ""} {config.postTitle} {currentPage >1 ? `( page ${currentPage} )` : ""}</title>
                        <meta name="description" content={cropText(contentRawToText(this.props.contentRaw), 150)}/>
                        {this.props.redirectToLastPage && totalPage > 1 && totalPage !== currentPage ? (
                                <meta name="prerender-status-code" content="302" />
                        ) : null}
                        {this.props.redirectToLastPage && totalPage > 1 && totalPage !== currentPage ? (
                            <meta name="prerender-header" content={`Location : ${canonical(`${url}/${totalPage}`, "", "topic")}`} />
                            ) : null}
                        {currentPage === 2 && (<link rel="prev" href={canonical(url, "", "topic")}/>)}
                        {currentPage >= 3 && (<link rel="prev" href={`${canonical(`${url}/${(currentPage - 1)}`, "", "topic")}`} />)}
                        <link rel="canonical" href={currentPage >1 ? `${canonical(`${url}/${currentPage}`, "", "topic")}` : canonical(url, "", "topic")} />
                        {currentPage < totalPage && (<link rel="next" href={`${canonical(`${url}/${(currentPage + 1)}`, "", "topic")}`} />)}
                    </Helmet>
                    <div className={"title-wrapper"}>
                        <div className="title-category">
                            <div className={"title"}>
                                {/*<span><Link to={"/"}>Accueil</Link></span>*/}
                                {/*<span><Link to={createLink("forum")}>Forums</Link></span>*/}

                                {this.props.breadcrumbsInitialized && (<Breadcrumbs data={breadCrumbsData}  />)}
                                {/*<span>*/}
                                {/*    {this.props.title}*/}
                                {/*</span>*/}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="topic">
                    {this.state.filter.page >= 2 ? (
                        <div className="follow-topic column pb-8">
                            {/*{this.props.currentUser._id && (*/}
                            <TopicFollows
                                forumId={this.props.forumId}
                                topicId={this.props._id}
                                isFollow={this.props.isFollow}
                            />
                            {/*)}*/}
                        </div>
                    ) : null}
                    {this.state.filter.page === 1 ? (
                        <TopicHeader currentUser={this.props.currentUser}
                                     currentPage={this.state.filter.page}
                                     authorName={this.props.authorName}
                                     title={this.props.title}
                                     content={this.props.content}
                                     contentRaw={this.props.contentRaw}
                                     tags={this.props.tags}
                                     createdAt={this.props.createdAt}
                                     isApproved={this.props.isApproved}
                                     isOpened={this.props.isOpened}
                                     isPinned={this.props.isPinned}
                                     isPoll={this.props.isPoll}
                                     totalPage={totalPage}
                                     handleChangePage={this.handleChangePage}
                                     slug={this.props.slug}
                                     forumId={this.props.forumId}
                                     useSign={this.props.useSign}
                                     forum={this.props.forum}
                                     _id={this.props._id}
                                     filter={this.state.filter}
                                     isFollow={this.props.isFollow}
                                     match={this.props.match}
                                     history={this.props.history}
                                     deleteTopic={this.props.deleteTopic}
                                     quote={this.quote}
                                     quotesIds={this.state.quotesIds}
                                     handleMultipleQuotes={this.handleMultipleQuotes}
                                     owner={this.props.owner}/>
                    ) : null}

                    {!this.props.commentsLoading && this.props.commentsError && (this.props.commentsError.status === "400" || this.props.commentsError.status === "500") && (
                        <div className="warning">Impossible de charger les comments</div>)}
                    {this.props.commentsLoading && <LoadingBar /> }

                    <div className="wrapper-settings">
                        {totalPage > 1 &&
                        <Pagination
                            currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            paginationLength={7}
                            link={createLink("forumTopic", {categoryParent : {slug : this.props.match.params.slugParent}, category : {_id : this.props.forum._id, slug : this.props.forum.slug}, topic : {_id : this.props._id, slug : this.props.slug}})}
                            handleChangePage={this.handleChangePage}
                        />
                        }
                    </div>
                    <CommentsList
                        articleId={this.props._id}
                        commentaires={this.props.comments}
                        currentUser={this.props.currentUser}
                        quotesIds={this.state.quotesIds}
                        handleMultipleQuotes={this.handleMultipleQuotes}
                        quote={this.quote}
                        multipleCheckbox={this.state.multipleCheckbox}
                        handleMultipleCheckbox={this.handleMultipleCheckbox}
                        tags={this.props.tags}
                        poll={this.props.poll}
                        deleteArticle={this.deleteArticle}
                        forumId={this.props.forumId}
                        topicId={this.props._id}
                        waitingDraft={this.state.waitingDraft}
                        resetComment={this.resetComment}
                    />
                    <div className="wrapper-settings">
                        {totalPage > 1 &&
                        <Pagination
                            currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            paginationLength={7}
                            link={createLink("forumTopic", {categoryParent : {slug : this.props.match.params.slugParent}, category : {_id : this.props.forum._id, slug : this.props.forum.slug}, topic : {_id : this.props._id, slug : this.props.slug}})}
                            handleChangePage={this.handleChangePage}
                        />
                        }
                        {this.state.loadingActionGroup && (
                            <div className="row loading-modif"><SpinLoader/> modifications en cours
                                des {this.state.multipleCheckbox.length} message(s) :</div>)}
                        {!this.state.loadingActionGroup && this.state.multipleCheckbox.length >= 2 && (
                            <div className="admin-select">

                                Avec {this.state.multipleCheckbox.length} message(s) coché(s) :
                                <Dropdown align="right" activableComponent={(
                                    <Button className="checkbox-action"
                                            btnStyle={"cancel-reverse"}
                                            size={"small"}
                                            content={"Modification à effectuer"}/>
                                )}>
                                    <ul className="dropdown-menu">
                                        <li className="menu-item"
                                            onClick={() => this.handleActionGroup('hidden')}>Cacher
                                        </li>
                                        <li className="menu-item"
                                            onClick={() => this.handleActionGroup('delete')}>Supprimer
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                        )}
                    </div>
                    {this.props.isOpened && this.props.currentUserInitialized &&
                            <div className="form-post-answer" id="ckeditor">
                                <div className="input-group">
                                    <MkEditor onChange={(content) => this.setState({topicComment: {...this.state.topicComment, contentRaw: content}})}
                                              extendedProps={{
                                                  forumId : this.props.forumId,
                                                  topicId : this.props._id,
                                                  kind : "topicComments"
                                              }}
                                              kind={"topicComments"}
                                              disabledSurvey={false}
                                              // handleCreateDraft={this.handleCreateDraft}
                                              waitingDraft={this.state.waitingDraft}
                                              commentInitialized={this.props.commentInitialized}
                                              commentSubmitting={this.props.commentSubmitting}
                                              ref={this.editorRef}
                                              forumId={this.props.forumId}
                                              topicId={this.props._id}
                                              quoteIds={this.state.quoteIds}/>

                                    <Can action={"create"} subject={this.props} modelName="TopicComment" passThrough>
                                        {can => {
                                            return can ? (
                                                <div className="btn-group">
                                                    <Button size={"small"}
                                                            btnStyle={"primary-reverse"}
                                                            onClick={() => this.handleSubmit()}
                                                            content={"Répondre"}/>
                                                </div>
                                            ) : (
                                                <div className="btn-group">
                                                    <CtaCannot action={"createComment"} isModal={true} button={{content : "Répondre", disabled :this.editorRef.current && !this.editorRef.current.handleHasText()}} />
                                                </div>
                                            )}}
                                    </Can>
                                </div>
                            </div>

                    }
                    <Authenticated passThrough>
                        {authenticated=>{
                            return !authenticated && (
                                <div className="form-post-answer" id="ckeditor">
                                    <div className="form-post-answer-title">Veuillez vous <Link
                                        to={createLink("signin")}>connecter</Link> pour répondre à ce sujet</div>
                                </div>
                            )}}
                    </Authenticated>
                    {this.state.quotesIds.length >= 2 && (
                        <div className="forums-topic-multiCitation-popup">
                            <Button size={"small"}
                                    btnStyle={"primary"}
                                    onClick={() => this.submitQuotations()}
                                    content={`Répondre à/aux ${this.state.quotesIds.length || 0} message(s) cité(s)`}/>
                            <span className={"clean-multiple-quote"} onClick={() => this.setState({quotesIds: [], multipleQuotes: []})}>Effacer</span>
                        </div>
                    )}
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        comment: state.forumComment.data,
        commentInitialized: state.forumComment.initialized,
        commentSubmitting: state.forumComment.submitting,

        comments: state.forumComments.data,
        commentsLoading: state.forumComments.loading,
        commentsInitialized: state.forumComments.initialized,
        commentsTotal: state.forumComments.total,
        commentsError: state.forumComments.error,

        currentUser: state.currentUser.data,
        currentUserInitialized: state.currentUser.initialized,
        breadcrumbs : state.forumBreadcrumbs.data,
        breadcrumbsInitialized : state.forumBreadcrumbs.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumComments,
    updateForumTopic,
    deleteForumTopic,
    moveForumTopic,
    fetchForumBreadcrumbs,
    resetForumBreadcrumbs,

    createForumComment,
    updateForumComment,
    deleteForumComment,
    resetForumComment,

    resetForumComments
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Topic);